<template>
  <div class="platform-apply-container">
    <el-form
      :model="form"
      :rules="rules"
      ref="form"
      label-width="120px"
      class="platform-apply-form"
    >
      <el-form-item label="logo" prop="logo">
        <el-upload
          class="platform-upload"
          :limit="1"
          action=""
          list-type="picture-card"
          :on-remove="handleRemove"
          :http-request="uploadFile"
          :before-upload="beforeUpload"
          accept="image/jpeg,image/jpg,image/png"
          :file-list="fileList"
        >
          <i class="el-icon-plus"></i>
        </el-upload>
      </el-form-item>
      <el-form-item label="业务线" prop="lineId">
        <el-select
          class="form-input"
          v-model="form.lineId"
          placeholder="请选择业务线"
          filterable
        >
          <el-option
            v-for="item in lineList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
        <el-button
          v-if="userInfo.isAdmin"
          icon="el-icon-circle-plus-outline"
          class="new-button"
          type="text"
          @click="showNewLine"
          >新增业务线</el-button
        >
      </el-form-item>
      <el-form-item label="负责人" prop="managerId">
        <el-select
          class="form-input"
          v-model="form.managerId"
          placeholder="请选择人员"
          filterable
          @change="changeManager"
        >
          <el-option
            v-for="item in memberList"
            :key="item.id"
            :label="`${item.realName}(${item.userName})`"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="用户鉴权方式" prop="authType">
        <el-select
          class="form-input"
          v-model="form.authType"
          placeholder="请选择用户鉴权方式"
        >
          <el-option label="麒麟体系（kylin）" value="kylin"></el-option>
          <el-option label="电商体系（userKey）" value="userKey"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="OSS类型" prop="type">
        <el-select
          class="form-input"
          v-model="form.type"
          placeholder="请选择OSS类型"
        >
          <el-option label="阿里云" value="aliCloud"></el-option>
          <el-option label="腾讯云" value="tencentCloud"></el-option>
          <el-option disabled label="京东云" value="jdCloud"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="平台标识" prop="slug">
        <el-select
          :disabled="isEdit"
          class="form-input"
          v-model="form.slug"
          placeholder="请选择美杜莎项目slug"
          clearable
          filterable
          remote
          :remote-method="getProjects"
          :loading="loading"
          @change="changeSlug"
        >
          <el-option
            v-for="item in projectList"
            :key="item.slug"
            :label="`${item.project_name}（${item.slug}）`"
            :value="item.slug"
          >
          </el-option>
        </el-select>
        <el-button
          icon="el-icon-circle-plus-outline"
          class="new-button"
          type="text"
          @click="handleNewProject"
          >新增项目slug</el-button
        >
      </el-form-item>
      <el-form-item label="平台名称" prop="name">
        <el-input v-model="form.name" placeholder="请输入平台名称"></el-input>
      </el-form-item>
      <el-form-item label="存储桶" prop="bucket">
        <el-input
          v-model="form.bucket"
          :placeholder="placeholder.bucketPlaceholder"
        ></el-input>
      </el-form-item>
      <el-form-item label="存储桶地区" prop="bucketRegion">
        <el-input
          v-model="form.bucketRegion"
          :placeholder="placeholder.bucketRegionPlaceholder"
        ></el-input>
      </el-form-item>
      <el-form-item label="CDN加速域名" prop="cdn">
        <el-input
          v-model="form.cdn"
          placeholder="请输入CDN加速域名（若无可不填，返回源站地址），例如：https://uat-xps-cdn.xsyx.xyz"
        ></el-input>
      </el-form-item>
      <el-form-item label="平台描述" prop="desc">
        <el-input
          type="textarea"
          v-model="form.desc"
          placeholder="请输入平台描述"
        ></el-input>
      </el-form-item>
      <el-form-item>
        <template v-if="!isEdit">
          <el-button
            type="primary"
            @click="submitForm('form')"
            :loading="submitLoading"
            >立即创建</el-button
          >
          <el-button @click="resetForm('form')">重置</el-button>
        </template>
        <template v-else>
          <el-button
            type="primary"
            @click="submitForm('form')"
            :loading="submitLoading"
            >立即修改</el-button
          >
          <el-button @click="closeHandle">取消</el-button>
        </template>
      </el-form-item>
    </el-form>

    <!-- 对话框 -->
    <el-dialog
      append-to-body
      :top="dialog.top"
      :title="dialog.title"
      :visible.sync="dialog.visible"
      :width="dialog.width"
      :before-close="destroyComponent"
    >
      <component
        :is="dialog.component"
        @close="destroyComponent"
        @getLineList="getLineList"
      />
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { dialogMixin } from "@/common/mixins/";
import { getExt } from "@/common/utils/ext.js";
import newSlug from "@/views/fileManage/components/newSlug.vue";
import lineForm from "./lineForm.vue";
import { lineApi, medusaApi, userApi, platformApi, xpsApi } from "@/api/index";
export default {
  mixins: [dialogMixin],
  props: {
    isEdit: {
      type: Boolean,
      default: false,
    },
    platformInfo: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      form: {
        logo: "",
        lineId: "",
        managerId: "",
        managerName: "",
        slug: "",
        name: "",
        authType: "kylin",
        type: "aliCloud",
        bucket: "",
        bucketRegion: "",
        cdn: "",
        desc: "",
      },
      rules: {
        lineId: [
          { required: true, message: "请选择业务线", trigger: "change" },
        ],
        managerId: [
          { required: true, message: "请选择业务线负责人", trigger: "change" },
        ],
        name: [{ required: true, message: "请输入平台名称", trigger: "blur" }],
        slug: [
          { required: true, message: "请选择平台标识", trigger: "change" },
        ],
        authType: [
          { required: true, message: "请选择用户鉴权方式", trigger: "change" },
        ],
        bucket: [{ required: true, message: "请输入存储桶", trigger: "blur" }],
        bucketRegion: [
          { required: true, message: "请输入存储桶区域", trigger: "blur" },
        ],
        type: [{ required: true, message: "请选择oss类型", trigger: "change" }],
      },
      loading: false,
      submitLoading: false,
      projectList: [],
      memberList: [],
      lineList: [],
      fileList: [],
    };
  },
  computed: {
    ...mapGetters(["userInfo"]),
    placeholder() {
      let placeholder = {};
      switch (this.form.type) {
        case "aliCloud":
          placeholder = {
            bucketPlaceholder: "请输入阿里云存储桶，例如：xsyx-front-xps-uat",
            bucketRegionPlaceholder:
              "请输入阿里云存储桶区域，例如：oss-cn-shenzhen",
          };
          break;
        case "tencentCloud":
          placeholder = {
            bucketPlaceholder:
              "请输入腾讯云存储桶，例如：xsyx-front-xps-uat-1259014075",
            bucketRegionPlaceholder:
              "请输入腾讯云存储桶区域，例如：ap-shanghai",
          };
          break;
        default:
          placeholder = {
            bucketPlaceholder: "请输入京东云存储桶，例如：xsyx-front-xps-uat",
            bucketRegionPlaceholder:
              "请输入京东云存储桶，例如：xsyx-front-xps-uat",
          };
          break;
      }
      return placeholder;
    },
  },
  mounted() {
    this.getLineList();
    this.getProjects();
    this.getAllUserList();
    if (this.isEdit) {
      this.initEditData();
      // Object.assign(this.form, this.platformInfo)
    } else {
      this.form.managerId = this.userInfo.id;
      this.form.managerName = this.userInfo.realName;
    }
  },
  methods: {
    // 初始化编辑表单信息
    initEditData() {
      this.form.logo = this.platformInfo.logo || this.form.logo;
      if (this.form.logo) {
        this.fileList = [{ name: this.form.logo, url: this.form.logo }];
      }
      this.form.managerId = this.platformInfo.managerId || this.form.managerId;
      this.form.managerName =
        this.platformInfo.managerName || this.form.managerName;
      this.form.slug = this.platformInfo.slug || this.form.slug;
      this.form.lineId = this.platformInfo.lineId || this.form.lineId;
      this.form.name = this.platformInfo.name || this.form.name;
      this.form.authType = this.platformInfo.authType || this.form.authType;
      this.form.type = this.platformInfo.type || this.form.type;
      this.form.desc = this.platformInfo.desc || this.form.desc;
      this.form.bucket = this.platformInfo.bucket || this.form.bucket;
      this.form.bucketRegion =
        this.platformInfo.bucketRegion || this.form.bucketRegion;
      this.form.cdn = this.platformInfo.cdn || this.form.cdn;
    },
    // 关闭弹窗
    closeHandle() {
      this.$emit("close");
    },
    // 新增业务线
    showNewLine() {
      this.setDialog(true, "新增业务线", lineForm, "600px", "25vh");
    },
    // 新增medusa项目
    handleNewProject() {
      this.setDialog(true, "新增美杜莎项目", newSlug, "600px", "25vh");
    },
    // 改变业务线负责人触发
    changeManager(val) {
      const member = this.memberList.find((item) => item.id === val);
      this.form.managerName = member ? member.realName : "";
    },
    // 改变项目slug触发
    changeSlug(val) {
      const project = this.projectList.find((item) => item.slug === val);
      this.form.name = project ? project.project_name : "";
    },
    // 文件移除
    handleRemove() {
      this.form.logo = "";
    },
    // 文件上传时的钩
    beforeUpload(file) {
      const types = ["image/jpeg", "image/jpg", "image/png"];
      const isImage = types.includes(file.type);
      const isLtSize = file.size / 1024 / 1024 < 10;
      if (!isImage) {
        this.$message.warning("上传二维码只能是 JPG、JPEG、PNG 格式!");
        return false;
      } else if (!isLtSize) {
        this.$message.warning("上传二维码大小不能超过 10MB!");
        return false;
      } else {
        return true;
      }
    },
    // 上传文件
    async uploadFile(params) {
      const form = new FormData();
      // 文件对象
      form.append("file_data", params.file);
      form.append("fileName", params.file.name);
      form.append("fileExt", getExt(params.file.name));
      form.append("source", "xps-platform");
      console.log(123);
      try {
        let res = await xpsApi.openApi(form);
        this.form.logo = res.cdnPath;
        this.$message.success("logo上传成功！");
      } catch (e) {
        console.log("uploadRequest error", e);
        that.$message.error("上传图片出错或文件过大！");
        return null;
      }
    },
    // 获取业务线列表
    async getLineList() {
      const res = await lineApi.getLineList();
      if (res.code === 200) {
        this.lineList = res.data;
      } else {
        this.$message.error(res.message);
      }
    },
    // 获取用户列表
    async getAllUserList() {
      const res = await userApi.getAllUserList();
      if (res.code === 200) {
        this.memberList = res.data;
      } else {
        this.$message.error(res.message);
      }
    },
    // 获取项目列表
    getProjects(searchStr) {
      this.loading = true;
      setTimeout(async () => {
        this.loading = false;
        const res = await medusaApi.getProjects({ searchStr });
        if (res.code) {
          this.projectList = res.data;
        }
      }, 200);
    },
    // 销毁动态组件
    destroyComponent() {
      this.setDialog(false, "", null, "1100px", "1vh");
    },
    // 提交表单
    submitForm(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          try {
            this.submitLoading = true;
            let res;
            if (this.isEdit) {
              res = await platformApi.updatePlatform(this.form);
              this.$emit("getPlatformList");
              this.$emit("close");
            } else {
              res = await platformApi.newPlatform(this.form);
              this.$emit("changeTab", "list");
            }
            if (res.code === 200) {
              this.$message.success(res.message);
            } else {
              this.$message.error(res.message);
            }
          } catch (error) {
            console.log(error);
          } finally {
            this.submitLoading = false;
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
  },
};
</script>

<style lang="scss">
.platform-apply-container {
  .platform-apply-form {
    .platform-upload {
      .el-upload {
        width: 148px;
      }
    }
    .form-input {
      width: 300px;
    }
    .new-button {
      margin-left: 15px;
    }
  }
}
</style>
